<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>What is a Market Map?</h2>
    <p>Market maps can help you shortlist and verify the top companies in a target country and sub-sector enabling you to isolate legitimate clients, customers, distributors or competitors to support your Africa growth strategy. Asoko's market maps are leveraged by leading investors, banks and MNCs across the globe looking to cut down on their research costs.</p>
    <p>Data included for each company comprises: registered name and address, registration ID, incorporation date, sub-sector classification and principal activities, revenue band, shareholder description and key personnel.</p>
    <div class="action-wrap">
      <a @click="openMarketMap" class="cta-button" :class="colorMode === 'light' ? 'medium-button' : ''">Learn More</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'market-map-conversion',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openMarketMap() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Market Map Conversion Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Market Map Conversion Block',
      })
      this.$router.push('/about/solutions/market-map')
    },
  },
}
</script>
